import { getRoles, clearLocalStorage } from "@/services/config";
import KeycloakService from "@/services/keycloak/keycloakService";

export function guardAdminIOSI(to: any, from: any, next: any) {
    if(getRoles() == "ADMIN_IOSI"){ 
        next()
    } else {
        KeycloakService.CallLogout();
        clearLocalStorage();
    }
    
}